import { type ComponentProps, type ReactElement } from 'react';
import { TdsIcon } from '@scania/tegel-react';
import clsx from 'clsx';
import styles from './style.module.scss';

type TdsIconProperties = ComponentProps<typeof TdsIcon>;

interface CountCardProperties {
  readonly header: string;
  readonly count: number;
  readonly iconName: TdsIconProperties['name'];
  readonly iconColorClassName?: string;
}

const CountCard = ({ header, count, iconName, iconColorClassName }: CountCardProperties): ReactElement => (
  <article className={styles.container}>
    <div data-testid="count-card-icon" className={clsx(styles.icon, iconColorClassName)}>
      <TdsIcon name={iconName} size="24px" />
    </div>
    <div className={styles.content}>
      <h2 className={styles.header}>{header}</h2>
      <div className={styles.count}>{count}</div>
    </div>
  </article>
);

export default CountCard;
